import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/storage'

import http from '../plugins/api';

const imagesPath = 'images'

const metadata = {
    contentType: 'image/png'
}

const storage = {
    state: {
        imageList: [],
        imageURL: 'https://neos.crellutions.at/api/image',
        baseURL : 'https://neos.crellutions.at/'
    },
    mutations: {
        SET_IMAGE_LIST(state, payload) {
            state.imageList = payload
        },
        ADD_IMAGE(state, image) {
            console.log('add image')
            console.log(image)
            let entity = state.imageList.find(item => item.id === image.id)

            if (!entity) {
                console.log('pushimage')
                image.src = state.baseURL + image.path +'/' + image.filename
                state.imageList.push(image)
            }
        },
        CLEAR_IMAGELIST(state){
            state.imageList.length = 0;
        }
    },
    actions: {
        uploadImage({commit}, image) {
            console.log(`[Storage] Upload image: ${image.id}`)

            let storageRef = firebase.storage().ref()
            let imageRef = storageRef.child(`${imagesPath}/${image.id}.png`)

            // Upload blob
            let uploadTask = imageRef.put(image.blob, metadata)

            // Listen to changes
            uploadTask.then(() => {
                uploadTask.snapshot.ref.getDownloadURL()
                    .then(url => {
                        let entity = { id: image.id, src: url}
                        commit('ADD_IMAGE', entity)
                    })
            })
        },
        loadImage({commit, state}, imageId) {
            console.log(`[Storage] Load image: ${imageId}`)

            // Shortcut to avoid unnecessary web-service calls
            if (state.imageList.map(item => item.id).includes(imageId)) {
                console.log(`[Storage] Image already loaded. Abort (${imageId})`)
                return
            }

            let storageRef = firebase.storage().ref()
            storageRef.child(`${imagesPath}/${imageId}.png`).getDownloadURL()
                .then(url => {
                    let entity = { id: imageId, src: url}
                    commit('ADD_IMAGE', entity)
                })
                .catch((err) => {
                    console.log(`[Storage] Failed: ${err.code}`)
                })
        },
        loadImageNEW({commit}, {type, refId}) {
//            console.log("enter new loadfunction in store");

            http.loadImages(type, refId)
                .then(images => {
//                    console.log('loaded')
//                    console.log(images)
                    images.forEach( image => {
                        commit('ADD_IMAGE',image)
                    }
                    )
                });
        },
        clearImageList({commit}) {
            console.log("clear images")
            commit('CLEAR_IMAGELIST')
        },
        deleteImage({commit, state}, imageId) {
            console.log(`[Storage] Delete image: ${imageId}`)

            let storageRef = firebase.storage().ref()
            storageRef.child(imageId).delete()
                .then(() => {
                    console.log(`[Storage] Deleted`)

                    let result = state.imageList.filter(image => {
                        return image.id !== imageId
                    })

                    commit('SET_IMAGE_LIST', result)
                })
                .catch((err) => {
                    console.log(`[Storage] Failed: ${err.code}`)
                })
        }
    },
    getters: {
        imageList(state) {
            return state.imageList
        },
        imageURL(state){
            return state.imageURL
        }
    }
}

export default storage
